import React from 'react'
import { Form, Dropdown } from 'react-bootstrap'
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete'
import useOnclickOutside from 'react-cool-onclickoutside'
import { useFormState, useFormContext } from 'react-hook-form'

const LocationInput = ({ name, requestOptions = {} }) => {
  const {
    control,
    setValue: setFieldValue,
    register,
    getValues,
  } = useFormContext()
  const { errors } = useFormState({ control })
  const error = errors[name]
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete({ requestOptions, debounce: 300 })
  const ref = useOnclickOutside(() => {
    // When user clicks outside of the component, we can dismiss
    // the searched suggestions by calling this method
    clearSuggestions()
  })

  const handleInput = e => {
    // Update the keyword of the input element
    setValue(e.target.value)
    // setFieldValue(name, e.target.value)
  }

  const handleSelect =
    ({ description }) =>
    () => {
      // When user selects a place, we can replace the keyword without request data from API
      // by setting the second parameter to "false"
      setValue(description, false)
      clearSuggestions()

      // Get latitude and longitude via utility functions
      getGeocode({ address: description })
        .then(results => getLatLng(results[0]))
        .then(({ lat, lng }) => {
          setFieldValue('location', description)
          setFieldValue('latitude', String(lat))
          setFieldValue('longitude', String(lng))
          getValues()
        })
        .catch(error => {
          console.error('Error: ', error)
        })
    }

  const renderSuggestions = () =>
    data.map(suggestion => {
      const {
        place_id,
        structured_formatting: { main_text, secondary_text },
      } = suggestion

      return (
        <Dropdown.Item key={place_id} onClick={handleSelect(suggestion)}>
          <strong>{main_text}</strong> <small>{secondary_text}</small>
        </Dropdown.Item>
      )
    })

  const locationInput = register(name)

  return (
    <div ref={ref}>
      <Form.Control
        className="form-control"
        value={value}
        disabled={!ready}
        name={name}
        placeholder=""
        isInvalid={!!error}
        {...locationInput}
        onChange={e => {
          locationInput.onChange(e)
          handleInput(e)
        }}
      />
      {/* We can use the "status" to decide whether we should display the dropdown or not */}
      {status === 'OK' && (
        <Dropdown.Menu show>{renderSuggestions()}</Dropdown.Menu>
      )}
      {!!error && (
        <Form.Control.Feedback type="invalid" className="mb-3">
          {error.message}
        </Form.Control.Feedback>
      )}
    </div>
  )
}

export default LocationInput
